import React from "react";
import SearchResult from "../SearchResult/SearchResult";
import "./SearchResultList.css";

interface SearchResultListProps {
    results: {
        documentName: string;
        fileType: string;
        author: string;
        lastModified: string;
        highlights: { page: number; text: string }[];
    }[];
}

function SearchResultList({ results }: SearchResultListProps) {
    return (
        <div className="search-results-list">
            {results.map((result, index) => (
                <SearchResult key={index} {...result} />
            ))}
        </div>
    );
}

export default SearchResultList;
